export default __webpack_public_path__ + "static/media/logo.15f10ac6.png";